export {
  createEdgeRuntimeAPI,
  getEdgeRuntimeResponse,
} from "./runtimes/edge/createEdgeRuntimeAPI";
